// import * as xss from 'xss';


$.ajaxSetup({
    dataType: 'json'
});

const GetSet = new Set();
const PostSet = new Set();
const Hash = {};
const prefix = 'erds-';
let counter = _.now();

function getKey() {
    return prefix + counter ++;
}

// let myxss = new xss.FilterXSS({
//     whiteList: xss.getDefaultWhiteList(),
//     onTagAttr: function (tag, name, value) {
//         if (name === "href" || name === "src") {
//             return `${name}=${value}`;
//         }
//     }
// });

function filterScript(str) {
    return str.replace(/<script/g, "&lt;script").replace(/<\/script/g, "&lt;/script").replace(/script>/g, "script&gt;");
}

let paths = [
    'login',
    'bi',
    'datagrid',
    'wf',
    'iframe',
    'calendar_mgr',
    'index',
    'form',
    'search_result'
];
function getCatologFromUrl() {
    let path = window.location.pathname;
    let catalog = '';
    let index = path.length;
    let found = false;

    if (!_.isUndefined(window.top.config && window.top.config.url_prefix)) {
        catalog = window.top.config.url_prefix;
        return catalog.replace(/\//g, '');
    }

    if (path === '') {
        return catalog;
    }
    paths.forEach((str) => {
        let _index = path.indexOf(`/${str}/`);
        if (_index > -1) {
            found = true;
            index = Math.min(index, _index);
        }
    });
    if (found) {
        catalog = path.substr(1, index - 1);
    }
    return catalog;
}

let catalog = getCatologFromUrl();
function addCatalog(url) {
    if (_.startsWith(url, `/${catalog}/`)) {
        return url;
    } else {
        if (catalog) {
            return `/${catalog}${url}`;
        } else {
            return url;
        }
    }
}

function returnIframeUrl(url, param = {}) {
    let str = $.param(param);
    if (str) {
        url = url + (url.indexOf('?') === -1 ? '?' : '&') + str;
    }
    return addCatalog(url);
}

function xssObj(target) {
    if (target) {
        if (_.isString(target)) {
            try {
                let json = JSON.parse(target);
                if (_.isPlainObject(json)) {
                    let str = JSON.stringify(xssObj(json));
                    return str;
                } else {
                    return filterScript(target);
                }
            } catch (e){
                return filterScript(target);
            }

        } else if (_.isArray(target)) {
            target.forEach((item, index) => {
                target[index] = xssObj(item);
            });
            return target;
        } else if (_.isPlainObject(target)) {
            _.forEach(target, function(value, key) {
                target[key] = xssObj(value);
            });
            return target;
        } else {
            return target;
        }
    } else {
        return target;
    }

}

export const HTTP = {

    /**
     * 缓存的get请求，必须通过flush才能发送
     * @param url 请求的接口路径
     * @param params 请求的接口的参数
     * @returns {Promise}
     */
    get: function(url, params) {
        const key = getKey();
        GetSet.add({
            url: url,
            key: key,
            params: xssObj(params)
        });
        const promise = new Promise((resolve) => {
            Hash[key] = resolve;
        });
        return promise;
    },

    /**
     * 缓存的post请求，必须通过flush才能发送
     * @param url
     * @param params
     * @returns {Promise}
     */
    post: function(url, params) {
        const key = getKey();
        PostSet.add({
            url: url,
            key: key,
            params: xssObj(params)
        });
        const promise = new Promise((resolve) => {
            Hash[key] = resolve;
        });
        return promise;
    },

    /**
     * 发送所有缓存的请求， get和post单独分开发
     */
    flush: function() {

        let pipeUrl = addCatalog('/pipe/');

        if (GetSet.size > 0) {
            let array = [...GetSet];
            $.get(pipeUrl, {actions: JSON.stringify(array)})
                .then((response) => {
                    this._dealResponse(response);
                }).fail(() => {
                this._dealResponseError(array);
            });
            GetSet.clear();
        }

        if (PostSet.size > 0) {
            let array = [...PostSet];
            $.post(pipeUrl, {actions: JSON.stringify(array)})
                .then((response) => {
                    this._dealResponse(response);
                }).fail(() => {
                this._dealResponseError(array);
            });
            PostSet.clear();
        }
    },

    /**
     * 内部方法，不允许外部调研，处理ajax返回数据
     * @param response
     * @private
     */
    _dealResponse: function(response) {
        var data = response.data || {};
        for(let key in data) {
            if (Hash[key]) {
                Hash[key](data[key]);
                delete Hash[key];
            }
        }
    },

    /**
     * 内部方法，不允许外部调研，处理ajax请求失败
     * @param array
     * @private
     */
    _dealResponseError: function(array) {
        array.forEach(function(obj) {
            if (obj.key !== undefined && Hash[obj.key]) {
                Hash[obj.key]({
                    succ: 0,
                    msg: '请求失败'
                })
            }
        })
    },

    /**
     * 同$.get
     * @returns Deffered
     */
    getImmediately: function(url) {
        let args = _.toArray(arguments);
        args = xssObj(args);
        if (_.isString(url)) {
            url = addCatalog(url);
            args[0] = url;
        } else if (_.isObject(url)) {
            let _url = addCatalog(url.url);
            args[0].url = _url;
        }
        return $.get.apply($, args);
    },

    /**
     * 同$.post
     * @returns Deffered
     */
    postImmediately: function(url) {
        let args = _.toArray(arguments);
        args = xssObj(args);
        if (_.isString(url)) {
            url = addCatalog(url);
            args[0] = url;
        } else if (_.isObject(url)) {
            let _url = addCatalog(url.url);
            args[0].url = _url;
        }
        return $.post.apply($, args);
    },

    /**
     * 同$.ajax
     * @returns Deffered
     */
    ajaxImmediately: function() {
        let args = _.toArray(arguments);
        args = xssObj(args);
        let _url = addCatalog(args[0].url);
        args[0].url = _url;
        return $.ajax.apply($, args);
    }

}

export {getCatologFromUrl, addCatalog, returnIframeUrl};



// WEBPACK FOOTER //
// app/lib/http.js